module.exports = __webpack_public_path__ + "media/logos/stripe-3040d36d.svg";